(function () {
  if (window.__shinkaMessageRollerLoaded) {
    return;
  }
  window.__shinkaMessageRollerLoaded = true;

  var globalConfig = window.ShinkaMessageRollerConfig || {};
  var defaults = {
    selector: "[data-shinka-message-roller]",
    lineHeight: 24,
    viewportPaddingY: 9,
    viewportPaddingX: 12,
    speed: 12,
    pauseOnHover: true,
    messages: []
  };

  var config = {
    selector: typeof globalConfig.selector === "string" ? globalConfig.selector : defaults.selector,
    lineHeight: Number.isFinite(globalConfig.lineHeight) ? Number(globalConfig.lineHeight) : defaults.lineHeight,
    viewportPaddingY: Number.isFinite(globalConfig.viewportPaddingY)
      ? Number(globalConfig.viewportPaddingY)
      : defaults.viewportPaddingY,
    viewportPaddingX: Number.isFinite(globalConfig.viewportPaddingX)
      ? Number(globalConfig.viewportPaddingX)
      : defaults.viewportPaddingX,
    speed: Number.isFinite(globalConfig.speed) ? Number(globalConfig.speed) : defaults.speed,
    pauseOnHover: typeof globalConfig.pauseOnHover === "boolean" ? globalConfig.pauseOnHover : defaults.pauseOnHover,
    messages: Array.isArray(globalConfig.messages) ? globalConfig.messages : defaults.messages
  };

  var monthShort = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

  var escapeHtml = function (value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  };

  var formatDate = function (value) {
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return "-- --- --";
    }
    var day = String(date.getDate()).padStart(2, "0");
    var month = monthShort[date.getMonth()] || "---";
    var year = String(date.getFullYear()).slice(-2);
    return day + month + year;
  };

  var toLabel = function (item) {
    if (typeof item === "string") {
      return item;
    }

    var productTitle = String(item.productTitle || item.title || "Product").trim();
    var occurredAt = item.occurredAt || item.addedAt || item.sentAt || item.date || "";
    var eventType = String(item.eventType || "RESTOCK").toUpperCase();

    if (item.message) {
      return "[" + formatDate(occurredAt) + "] " + String(item.message);
    }

    var suffix = eventType === "AUTO_ADD"
      ? " is restocked & added to your cart 🛒🛒🛒"
      : " is restocked";

    return "[" + formatDate(occurredAt) + "] 🔔🔔🔔 " + productTitle + suffix;
  };

  var parseMessages = function (root) {
    var inline = root.getAttribute("data-messages") || "";
    if (inline) {
      try {
        var parsed = JSON.parse(inline);
        if (Array.isArray(parsed) && parsed.length) {
          return parsed;
        }
      } catch (_) {
        // Not JSON — treat as pipe-separated plain text strings.
        var parts = inline.split("|").map(function (s) { return s.trim(); }).filter(Boolean);
        if (parts.length) {
          return parts;
        }
      }
    }

    if (Array.isArray(config.messages) && config.messages.length) {
      return config.messages;
    }

    return [];
  };

  var applyCssVars = function (root) {
    root.style.setProperty("--shinka-roller-line-height", String(config.lineHeight) + "px");
    root.style.setProperty("--shinka-roller-padding-y", String(config.viewportPaddingY) + "px");
    root.style.setProperty("--shinka-roller-padding-x", String(config.viewportPaddingX) + "px");
  };

  var start = function (root) {
    var rawMessages = parseMessages(root);
    if (!rawMessages.length) {
      root.innerHTML = '<p class="shinka-message-roller-empty">No messages</p>';
      return;
    }

    var items = rawMessages.slice();

    applyCssVars(root);

    // Single message — just show it, no animation needed
    if (items.length === 1) {
      root.innerHTML =
        '<div class="shinka-message-roller__viewport">' +
        '  <ul class="shinka-message-roller__track">' +
        '    <li class="shinka-message-roller__line">' + escapeHtml(toLabel(items[0])) + "</li>" +
        "  </ul>" +
        "</div>";
      return;
    }

    // Build two copies of the track for seamless infinite loop
    var buildTrackHtml = function () {
      return items
        .map(function (item) {
          return '<li class="shinka-message-roller__line">' + escapeHtml(toLabel(item)) + "</li>";
        })
        .join("");
    };

    root.innerHTML =
      '<div class="shinka-message-roller__viewport" data-roller-viewport="true">' +
      '  <div class="shinka-message-roller__belt" data-roller-belt="true">' +
      '    <ul class="shinka-message-roller__track">' + buildTrackHtml() + "</ul>" +
      '    <ul class="shinka-message-roller__track">' + buildTrackHtml() + "</ul>" +
      "  </div>" +
      "</div>";

    var belt = root.querySelector("[data-roller-belt='true']");
    if (!belt) {
      return;
    }

    // Total height of one full set of messages
    var loopHeight = items.length * config.lineHeight;

    var offset = 0;
    var previous = performance.now();
    var paused = false;
    var frameId = null;

    if (config.pauseOnHover) {
      root.addEventListener("mouseenter", function () {
        paused = true;
      });
      root.addEventListener("mouseleave", function () {
        paused = false;
      });
    }

    belt.style.transform = "translate3d(0,0,0)";

    var tick = function (now) {
      var elapsed = (now - previous) / 1000;
      previous = now;

      if (!paused) {
        offset += config.speed * elapsed;

        // Modular wrap — seamless because second track is identical
        if (offset >= loopHeight) {
          offset -= loopHeight;
        }

        belt.style.transform = "translate3d(0," + (-offset) + "px,0)";
      }

      frameId = requestAnimationFrame(tick);
    };

    frameId = requestAnimationFrame(tick);

    root.__shinkaDestroyRoller = function () {
      if (frameId) {
        cancelAnimationFrame(frameId);
      }
    };
  };

  var boot = function () {
    var roots = Array.from(document.querySelectorAll(config.selector));
    roots.forEach(function (root) {
      if (root.__shinkaDestroyRoller) {
        root.__shinkaDestroyRoller();
      }
      start(root);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
